import React from 'react';
import { RadioButtonGroup } from 'react-rainbow-components';
import { useTranslation } from 'react-i18next';
import useMedia from 'use-media';

interface Props {
  value: number;
  valuesList: number[];
  disallowValues: number[];
  handleInput: any;
  title: string;
  smallTitle: string;
}

const ISDimensionSelector = ({
  value,
  valuesList,
  handleInput,
  disallowValues,
  title,
  smallTitle,
}: Props) => {
  const { t } = useTranslation();
  const isSmallMobile = useMedia({ maxWidth: 384 });

  const handleOnChange = (e: any) => {
    handleInput(parseInt(e.currentTarget.value));
  };

  const options = () => {
    const optionsHeight = [];
    for (const value of valuesList) {
      optionsHeight.push({
        value: `${value}`,
        label: `${value}mm`,
        disabled: disallowValues.includes(value),
      });
    }
    return optionsHeight;
  };

  return (
    <div className="flex items-center">
      <div className="text-gray-600 text-sm">
        {isSmallMobile ? smallTitle : title}
      </div>

      <div className="ml-2">
        <RadioButtonGroup
          id="radio-button-group-component-1"
          options={options()}
          value={`${value}`}
          onChange={handleOnChange}
        />
      </div>
    </div>
  );
};

export default ISDimensionSelector;
